import { Grid, Typography } from '@mui/material';
import { formatterPTY } from '../../../../utils/utils';

const DataGridTotalFooterColocacionDiaria = (props) => {
    return (
        <Grid container py={1}>
            <Grid
                item
                xs={props.donacionTotal ? 7.6 : 10}
                textAlign="start"
                pl={2.7}
            >
                <Typography variant="p" fontWeight="bold">
                    Total
                </Typography>
            </Grid>
            <Grid item xs={2} textAlign="start" pl={3.5}>
                <Typography variant="p" fontWeight="bold">
                    {props.total}
                </Typography>
            </Grid>
            {props.donacionTotal && (
                <Grid item xs={2} textAlign="start" pl={2.7}>
                    <Typography variant="p" fontWeight="bold">
                        {formatterPTY.format(props.donacionTotal)}
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
};

export default DataGridTotalFooterColocacionDiaria;
